import { useEffect, useState } from 'react';
import { useLanguage } from '@/common/hooks/useLanguageData';
import {
	ANALYTICS_EVENT,
	ANALYTICS_LANGUAGE_PLACEMENT,
} from '@/common/constants/analyticsEvents';
import { useAnalytics } from '@/common/contexts/AnalyticsContext';
import { resolveCurrentLanguage } from '../helpers/resolveCurrentLanguage';

export const useLanguageSwitcher = ({
	placement = ANALYTICS_LANGUAGE_PLACEMENT.TOPBAR,
} = {}) => {
	const { lang, switchLanguage } = useLanguage();
	const { trackAnalytics } = useAnalytics();
	const [open, setOpen] = useState(false);
	const currentLanguage = resolveCurrentLanguage(lang);

	useEffect(() => {
		if (!open) {
			return undefined;
		}

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				setOpen(false);
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [open]);

	const handleSelect = (code) => {
		if (code !== lang) {
			trackAnalytics(ANALYTICS_EVENT.LANGUAGE.SWITCH, {
				fromLang: lang,
				toLang: code,
				placement,
			});
			switchLanguage(code);
		}

		setOpen(false);
	};

	return {
		lang,
		open,
		currentLanguage,
		handleToggle: () => setOpen((prev) => !prev),
		handleClose: () => setOpen(false),
		handleSelect,
	};
};
